package id.neotica.neotica.domain.model

data class TechStacks(
    val title: String,
    val image: String,
    val url: String? = null
)